const ROUTES = {
    HOME: '/',
    WEBRTC: '/webrtc',
    USER_MANAGEMENT_OLD: '/user-management-old',
    USER_MANAGEMENT: '/user-management',
    NUMBER_MANAGEMENT: '/number-management',
    TEST_MOCK: '/test-mock',
};

export { ROUTES };
